export const llm = {
  defaultLLM: {
    key: 'defaultLLM',
    functionName: 'Select a LLM',
    variables: [],
    category: 'llm',
    hide: false
  }
}
